import { ApolloClient } from "@apollo/client";
import _ from "lodash";
import { LatestAssetRemoveEvent } from "../../graphql/queries/latestAssetRemoveEvent";

/**
 * `createInstalledBaseEvent` returns the relocation-side event of a removal /
 * exchange, not the ASSET_REMOVE event a declaration attaches to. Re-query the
 * asset's newest REMOVE event instead (the mutation has completed, so it is
 * already in the list). Returns null when nothing is found or the query fails.
 */
export const resolveLatestRemoveEventId = async (
    client: ApolloClient<unknown>,
    assetId: string,
): Promise<string | null> => {
    try {
        const { data } = await client.query({
            query: LatestAssetRemoveEvent,
            variables: { assetId },
            fetchPolicy: 'network-only',
        });
        const id = _.get(data, 'installedBaseEventList.installedBaseEvents[0].id');
        return id ? String(id) : null;
    } catch {
        return null;
    }
};
